import * as yup from 'yup';

export default yup.object().shape({
  _id: yup.string().required(),
  name: yup.string().trim().max(256),
  description: yup.string().trim().max(4096),
  properties: yup.object(),
});
